import React, { useState } from 'react';

const Fifththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (service) => {
        setCart([...cart, service]);
        alert(`Added ${service.service_name} to cart`);
    };
    return (
        <>
            <style>{`
        :root {
            /* Palette: Soft Luxury */
            --primary: #885053;
            /* Muted Rosy Brown */
            --primary-light: #d6b4b6;
            --secondary: #fdf2f2;
            /* Very light pink/warm white */
            --accent: #d4af37;
            /* Gold */
            --text-dark: #3a3a3a;
            --text-light: #757575;
            --white: #ffffff;
            --black: #1a1a1a;

            --shadow-soft: 0 10px 40px -10px rgba(136, 80, 83, 0.15);
            --shadow-hover: 0 20px 50px -10px rgba(136, 80, 83, 0.25);

            --radius-sm: 8px;
            --radius-lg: 24px;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: 'Lato', sans-serif;
            color: var(--text-dark);
            background-color: var(--secondary);
            line-height: 1.7;
            overflow-x: hidden;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font-family: 'Cormorant Garamond', serif;
            font-weight: 600;
            color: var(--black);
            line-height: 1.1;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.3s ease;
        }

        .container {
            max-width: 1240px;
            margin: 0 auto;
            padding: 0 24px;
        }

        .section {
            padding: 100px 0;
            position: relative;
        }

        .btn {
            display: inline-block;
            padding: 16px 40px;
            font-family: 'Lato', sans-serif;
            font-size: 0.85rem;
            letter-spacing: 1px;
            text-transform: uppercase;
            font-weight: 700;
            background: var(--black);
            color: var(--white);
            border: 1px solid var(--black);
            cursor: pointer;
            transition: all 0.4s ease;
        }

        .btn:hover {
            background: transparent;
            color: var(--black);
        }

        .btn-outline {
            background: transparent;
            color: var(--black);
            border: 1px solid var(--black);
        }

        .btn-outline:hover {
            background: var(--primary);
            color: var(--white);
            border-color: var(--primary);
        }

        .text-center {
            text-align: center;
        }

        /* Top Notification Bar */
        .top-bar {
            background-color: var(--white);
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            padding: 14px 0;
            font-size: 0.85rem;
            color: var(--text-light);
            letter-spacing: 0.5px;
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .contact-details {
            display: flex;
            gap: 28px;
        }

        .contact-item {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .social-icons {
            display: flex;
            gap: 16px;
        }

        /* Navigation */
        nav {
            padding: 24px 0;
            background: var(--secondary);
            position: sticky;
            top: 0;
            z-index: 100;
            transition: 0.3s;
        }

        nav.scrolled {
            background: rgba(253, 242, 242, 0.95);
            backdrop-filter: blur(10px);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
            padding: 16px 0;
        }

        nav .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .logo {
            font-family: 'Cormorant Garamond', serif;
            font-size: 2.2rem;
            font-weight: 700;
            letter-spacing: -0.5px;
            color: var(--black);
        }

        .logo span {
            color: var(--primary);
            font-style: italic;
        }

        .nav-links {
            display: flex;
            gap: 40px;
            list-style: none;
        }

        .nav-links a {
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            position: relative;
        }

        .nav-links a::after {
            content: '';
            position: absolute;
            bottom: -4px;
            left: 0;
            width: 0%;
            height: 1px;
            background: var(--primary);
            transition: 0.3s ease;
        }

        .nav-links a:hover::after {
            width: 100%;
        }

        /* Hero Header */
        header.hero {
            height: 90vh;
            min-height: 600px;
            background: url('https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80') no-repeat center center/cover;
            position: relative;
            display: flex;
            align-items: center;
        }

        header.hero::before {
            content: '';
            position: absolute;
            inset: 0;
            background: rgba(0, 0, 0, 0.2);
            /* Slight overlay */
        }

        .hero-content {
            position: relative;
            max-width: 600px;
            margin-left: 10%;
            /* Offset layout */
            color: var(--white);
        }

        .hero-subtitle {
            text-transform: uppercase;
            letter-spacing: 3px;
            font-size: 0.9rem;
            margin-bottom: 20px;
            display: block;
            color: rgba(255, 255, 255, 0.9);
        }

        .hero-title {
            font-size: 4.5rem;
            margin-bottom: 30px;
            color: var(--white);
            text-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .hero-desc {
            font-size: 1.1rem;
            margin-bottom: 40px;
            color: rgba(255, 255, 255, 0.9);
            max-width: 480px;
        }

        /* About Section */
        .decoration-text {
            font-family: 'Cormorant Garamond', serif;
            font-style: italic;
            font-size: 5rem;
            color: rgba(136, 80, 83, 0.05);
            /* Very faint primary color */
            position: absolute;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 0;
            white-space: nowrap;
        }

        .about-wrap {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 80px;
            align-items: center;
            position: relative;
            z-index: 1;
        }

        .about-images {
            position: relative;
            height: 600px;
        }

        .img-main {
            width: 80%;
            height: 90%;
            object-fit: cover;
            border-radius: 200px 200px 0 0;
            /* Arch shape */
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
        }

        .img-accent {
            width: 50%;
            height: 50%;
            object-fit: cover;
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 2;
            border: 8px solid var(--secondary);
        }

        .section-header span {
            color: var(--primary);
            text-transform: uppercase;
            font-size: 0.8rem;
            letter-spacing: 2px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
        }

        .section-header h2 {
            font-size: 3rem;
            margin-bottom: 24px;
        }

        .about-text p {
            color: var(--text-light);
            margin-bottom: 24px;
            font-size: 1.05rem;
        }

        .signature {
            font-family: 'Cormorant Garamond', serif;
            font-size: 2rem;
            color: var(--primary);
            margin-top: 30px;
            font-style: italic;
        }

        /* Categories / Services */
        .services-section {
            background-color: var(--white);
        }

        .services-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
            margin-top: 60px;
        }

        .service-card {
            text-align: center;
            padding: 40px;
            background: var(--secondary);
            border-radius: var(--radius-sm);
            transition: 0.4s ease;
        }

        .service-card:hover {
            transform: translateY(-10px);
            background: var(--white);
            box-shadow: var(--shadow-hover);
        }

        .service-icon {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background: var(--white);
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 24px;
            font-size: 2rem;
            color: var(--primary);
            transition: 0.4s;
        }

        .service-card:hover .service-icon {
            background: var(--primary);
            color: var(--white);
        }

        .service-card h3 {
            font-size: 1.5rem;
            margin-bottom: 16px;
        }

        .service-card p {
            font-size: 0.95rem;
            color: var(--text-light);
            margin-bottom: 24px;
            line-height: 1.6;
        }

        .service-link {
            font-size: 0.8rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: var(--black);
            font-weight: 700;
            border-bottom: 1px solid var(--black);
            padding-bottom: 2px;
        }

        .action-buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            margin-top: 20px;
        }

        .btn-action {
            flex: 1;
            padding: 10px 15px;
            font-size: 0.8rem;
            text-transform: uppercase;
            font-weight: 700;
            letter-spacing: 0.5px;
            border: 1px solid var(--black);
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
        }

        .btn-call {
            background: var(--white);
            color: var(--black);
        }

        .btn-call:hover {
            background: var(--black);
            color: var(--white);
        }

        .btn-enquiry {
            background: var(--black);
            color: var(--white);
        }

        .btn-enquiry:hover {
            background: var(--primary);
            border-color: var(--primary);
            color: var(--white);
        }

        .btn-order {
            background: var(--primary);
            color: var(--white);
            border-color: var(--primary);
        }

        .btn-order:hover {
            background: transparent;
            color: var(--primary);
        }

        /* Gallery */
        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 16px;
        }

        .gallery-item {
            height: 350px;
            overflow: hidden;
            position: relative;
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.8s ease;
        }

        .gallery-item:hover img {
            transform: scale(1.1);
        }

        .gallery-caption {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 24px;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
            color: var(--white);
            opacity: 0;
            transform: translateY(20px);
            transition: 0.4s ease;
        }

        .gallery-item:hover .gallery-caption {
            opacity: 1;
            transform: translateY(0);
        }

        /* Footer */
        footer {
            background: var(--black);
            color: rgba(255, 255, 255, 0.6);
            padding: 80px 0 30px;
            text-align: center;
        }

        .footer-logo {
            font-family: 'Cormorant Garamond', serif;
            font-size: 2.5rem;
            color: var(--white);
            margin-bottom: 24px;
            display: inline-block;
        }

        .footer-info {
            margin-bottom: 40px;
            font-size: 1.1rem;
            color: rgba(255, 255, 255, 0.8);
        }

        .footer-info p {
            margin-bottom: 8px;
        }

        .footer-socials {
            display: flex;
            justify-content: center;
            gap: 24px;
            margin-bottom: 60px;
        }

        .footer-socials a {
            color: var(--white);
            font-size: 1.2rem;
            opacity: 0.7;
        }

        .footer-socials a:hover {
            opacity: 1;
            color: var(--accent);
        }

        .copyright {
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            padding-top: 30px;
            font-size: 0.8rem;
            letter-spacing: 1px;
        }

        /* Responsive */
        @media (max-width: 992px) {
            .hero-title {
                font-size: 3.5rem;
            }

            .about-wrap {
                grid-template-columns: 1fr;
            }

            .about-images {
                height: 400px;
                margin-bottom: 40px;
            }

            .img-main {
                position: relative;
                width: 100%;
                height: 100%;
                border-radius: 20px;
            }

            .img-accent {
                display: none;
            }

            .services-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .gallery-grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }

        @media (max-width: 768px) {
            .top-bar {
                display: none;
            }

            /* Simplify for mobile */
            .nav-links {
                display: none;
            }

            /* Hide menu for simplicity in this demo */
            .hero-content {
                margin-left: 0;
                padding: 0 20px;
                text-align: center;
            }

            .hero-title {
                font-size: 2.5rem;
            }

            .section-header h2 {
                font-size: 2.2rem;
            }

            .services-grid {
                grid-template-columns: 1fr;
            }

            .gallery-grid {
                grid-template-columns: 1fr;
            }
        }
    `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link
                href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400;700&display=swap"
                rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="contact-details">
                        {get_data.business_location_name && (
                            <div className="contact-item">
                                <span>{get_data.business_location_name}</span>
                            </div>
                        )}
                        {get_data.email && (
                            <div className="contact-item">
                                <span>{get_data.email}</span>
                            </div>
                        )}
                        {get_data.mobile && (
                            <div className="contact-item">
                                <span>{get_data.mobile}</span>
                            </div>
                        )}
                    </div>
                    <div className="social-icons">
                        {get_data.facebook && (
                            <a href={get_data.facebook} target="_blank" rel="noopener noreferrer">
                                <span>FB</span>
                            </a>
                        )}
                        {get_data.instagram && (
                             <a href={get_data.instagram} target="_blank" rel="noopener noreferrer">
                                <span>IG</span>
                            </a>
                        )}
                        {get_data.twitter && (
                             <a href={get_data.twitter} target="_blank" rel="noopener noreferrer">
                                <span>TW</span>
                            </a>
                        )}
                         {get_data.youtube && (
                             <a href={get_data.youtube} target="_blank" rel="noopener noreferrer">
                                <span>YT</span>
                            </a>
                        )}
                    </div>
                </div>
            </div>

            {/* Navigation */}
            <nav>
                <div className="container">
                    <a href="#" className="logo">{get_data.service_name}<span>.</span></a>
                    <ul className="nav-links">
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#services">Treatments</a></li>
                        <li><a href="#gallery">Journal</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                    <a href="#contact" className="btn-outline" style={{padding: '10px 24px', fontSize: '0.75rem'}}>Book Appointment</a>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="container">
                    <div className="hero-content">
                        <span className="hero-subtitle">Holistic Beauty & Wellness</span>
                        <h1 className="hero-title">Rediscover Your Natural Radiance</h1>
                        <p className="hero-desc">Experience the perfect harmony of nature and science. Our premium spa treatments
                            are designed to rejuvenate your body and soul.</p>
                        <a href="#services" className="btn">Discover Treatments</a>
                    </div>
                </div>
            </header>

            {/* About Section */}
            <section className="section" id="about">
                <div className="decoration-text">Philosophy</div>
                <div className="container">
                    <div className="about-wrap">
                        <div className="about-images">
                            <img src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                                alt="Spa Treatment" className="img-main" />
                            <img src="https://images.unsplash.com/photo-1552693673-1bf958298935?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
                                alt="Spa Products" className="img-accent" />
                        </div>
                        <div className="about-text">
                            <div className="section-header">
                                <span>Our Philosophy</span>
                                <h2>The Art of Caring for You</h2>
                            </div>
                            <p>At Lumina Aesthetics, we believe that beauty is a reflection of inner wellness. Founded with a
                                passion for holistic health, our sanctuary offers a retreat from the chaos of modern life.</p>
                            <p>Our expert therapists combine ancient healing traditions with modern dermatological science to
                                use only the finest organic products. Every touch is intentional, every treatment personalized
                                to your unique needs.</p>
                            <p>We invite you to pause, breathe, and let us guide you on a journey to your most radiant self.</p>
                            <div className="signature">Isabella & Co.</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Categories / Services */}
            <section className="section services-section" id="services">
                <div className="container">
                    <div className="section-header text-center">
                        <span>Our Menu</span>
                        <h2>Curated Treatments</h2>
                        <p style={{maxWidth: '600px', margin: '0 auto', color: 'var(--text-light)'}}>We offer a wide range of beauty
                            services, each designed to provide relaxation and visible results.</p>
                    </div>

                    <div className="services-grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">
                                    {item.icon ? (
                                         <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} 
                                            alt={item.name}
                                            style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}}
                                        />
                                    ) : (
                                        <span>✦</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'No description available'}</p>
                                <div className="action-buttons">
                                    <a href={`tel:${get_data.mobile}`} className="btn-action btn-call">
                                        Call
                                    </a>
                                    <a href="#contact" className="btn-action btn-enquiry">
                                        Enquiry
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products / Product Services */}
            <section className="section services-section" id="products" style={{backgroundColor: 'var(--secondary)'}}>
                <div className="container">
                    <div className="section-header text-center">
                        <span>Our Products</span>
                        <h2>Exclusive Offerings</h2>
                        <p style={{maxWidth: '600px', margin: '0 auto', color: 'var(--text-light)'}}>Discover our range of premium products and specialized services.</p>
                    </div>

                    <div className="services-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="service-card" key={index} style={{backgroundColor: 'var(--white)'}}>
                                <div style={{width: '100%', height: '200px', marginBottom: '20px', borderRadius: 'var(--radius-sm)', overflow: 'hidden'}}>
                                    {item.featured_image ? (
                                         <img 
                                            src={item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                            alt={item.service_name}
                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0', color: '#ccc'}}>
                                            No Image
                                        </div>
                                    )}
                                </div>
                                <h3>{item.service_name}</h3>
                                <p style={{color: 'var(--primary)', fontWeight: 'bold', fontSize: '1.1rem'}}>
                                    {item.price ? `₹${item.price}` : 'Contact for Price'}
                                </p>
                                <p>{item.description || 'No description available'}</p>
                                <div className="action-buttons">
                                     <button onClick={() => addToCart(item)} className="btn-action btn-order">
                                        Order
                                    </button>
                                    <a href={`tel:${get_data.mobile}`} className="btn-action btn-call">
                                        Call
                                    </a>
                                    <a href="#contact" className="btn-action btn-enquiry">
                                        Enquiry
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* Testimonials Section */}
            <section className="section" id="reviews" style={{backgroundColor: 'var(--white)', paddingBottom: '120px'}}>
                <div className="container">
                    <div className="section-header text-center" style={{marginBottom: '60px'}}>
                        <span>Love Notes</span>
                        <h2>Client Experiences</h2>
                    </div>

                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '60px'}}>
                           {get_data.review_ratings.map((review, index) => (
                                <div key={index}
                                    style={{textAlign: 'center', padding: '40px', border: '1px solid var(--primary-light)', borderRadius: 'var(--radius-lg)', position: 'relative'}}>
                                    <span
                                        style={{fontSize: '4rem', color: 'var(--primary)', opacity: 0.2, fontFamily: "'Cormorant Garamond', serif", position: 'absolute', top: '-20px', left: '40px'}}>“</span>
                                    <p style={{fontSize: '1.2rem', marginBottom: '30px', fontStyle: 'italic', color: 'var(--text-light)'}}>
                                        "{review.review || 'No review text provided.'}"</p>
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
                                        <div style={{width: '70px', height: '70px', borderRadius: '50%', backgroundColor: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: '#888'}}>
                                            {review.user_name ? review.user_name.charAt(0).toUpperCase() : 'U'}
                                        </div>
                                        <h4 style={{fontSize: '1.1rem', color: 'var(--black)'}}>{review.user_name || 'Anonymous Client'}</h4>
                                        {/* Optional: Display star rating if available */}
                                        {review.rating && (
                                            <span style={{color: '#FFD700'}}>
                                                {'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}
                                            </span>
                                        )}
                                    </div>
                                </div>
                           ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-light)', fontStyle: 'italic'}}>
                            <p>No reviews yet. Be the first to share your experience!</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <a href="#" className="footer-logo">{get_data.service_name || 'Partner Store'}</a>
                    <div className="footer-info">
                        <p>{get_data.business_location_name}</p>
                        <p>{get_data.email}</p>
                        <p>{get_data.mobile}</p>
                    </div>
                    <div className="footer-socials">
                        {get_data.instagram && <a href={get_data.instagram}>Instagram</a>}
                        {get_data.facebook && <a href={get_data.facebook}>Facebook</a>}
                        {get_data.youtube && <a href={get_data.youtube}>Youtube</a>}
                        {get_data.twitter && <a href={get_data.twitter}>Twitter</a>}
                    </div>
                    <div className="copyright">
                        &copy; {new Date().getFullYear()} {get_data.service_name || 'Partner Store'}. All Rights Reserved.
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Fifththeme
